import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type ValuationBranchQueryVariables = Types.Exact<{
    branchId: Types.Scalars['Int'];
}>;

export type ValuationBranchQuery = { __typename?: 'Query' } & {
    valuationBranch: { __typename?: 'ValuationBranch' } & Pick<
        Types.ValuationBranch,
        | 'address'
        | 'averageRentPrice'
        | 'averageSalePrice'
        | 'branchDisplayName'
        | 'branchId'
        | 'logo'
        | 'numberOfSaleListings'
        | 'numberOfRentListings'
        | 'outcode'
        | 'postcode'
    >;
};

export const ValuationBranchDocument = gql`
    query ValuationBranch($branchId: Int!) {
        valuationBranch(branchId: $branchId) {
            address
            averageRentPrice
            averageSalePrice
            branchDisplayName
            branchId
            logo
            numberOfSaleListings
            numberOfRentListings
            outcode
            postcode
        }
    }
`;

/**
 * __useValuationBranchQuery__
 *
 * To run a query within a React component, call `useValuationBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuationBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuationBranchQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useValuationBranchQuery(
    baseOptions: Apollo.QueryHookOptions<
        ValuationBranchQuery,
        ValuationBranchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ValuationBranchQuery, ValuationBranchQueryVariables>(
        ValuationBranchDocument,
        options
    );
}
export function useValuationBranchLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ValuationBranchQuery,
        ValuationBranchQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ValuationBranchQuery,
        ValuationBranchQueryVariables
    >(ValuationBranchDocument, options);
}
export type ValuationBranchQueryHookResult = ReturnType<
    typeof useValuationBranchQuery
>;
export type ValuationBranchLazyQueryHookResult = ReturnType<
    typeof useValuationBranchLazyQuery
>;
export type ValuationBranchQueryResult = Apollo.QueryResult<
    ValuationBranchQuery,
    ValuationBranchQueryVariables
>;
